import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import SelectLang from '../../components/SelectLang';
import Onglet from '../../components/Onglet';
import Paging from '../../components/Paging';

import "./style.css"

function Works({ type }) {

    const worksDb = useSelector(state => state.works);

    const [worksData, setWorksData] = useState(null);
    const [paging, setPaging] = useState(0);

    useEffect(() => {
        localStorage.setItem('opt_return_work_pg_vanrah', 'works');

        if (!worksDb || worksDb.length === 0) {
            setWorksData(null);
            return
        }

        const worksTypeFiltered = worksDb.filter(w => w.type === parseInt(type));

        const chunkSize = 5;
        const chunkedData = [];

        for (let i = 0; i < worksTypeFiltered.length; i += chunkSize) {
            const chunk = worksTypeFiltered.slice(i, i + chunkSize);
            chunkedData.push(chunk);
        }

        setWorksData(chunkedData);
        setPaging(0);

    }, [worksDb, type]);

    const getPath = (work) => {
        const page_path = work.type === 1 ? 'mangas' : 'works';
        return `${page_path}/${work.title_path}`;
    }

    return (
        <div className='page page_works'>
            <p className="title_page">
                - <span>{type === 1 ? 'Mangas/Webcomics' : 'Other Works'}</span> -
            </p>

            <SelectLang />

            {worksData && worksData[paging] &&
                <section className="sect_works">
                    <ul className="works_list">
                        {worksData[paging].map((work, idx) => (
                            <li key={idx}>
                                <Onglet data={work} idx={idx} getPath={getPath} lines={true} />
                            </li>
                        ))}
                    </ul>

                    {worksData.length > 1 && <Paging data={worksData} paging={paging} setPaging={setPaging} />}
                </section>
            }
        </div>
    )
}

export default Works;